import React from 'react';
import Web3Warning from 'modules/wallet/web/web3Warning/web3Warning.component';
import { useCurrentWarning } from 'modules/wallet/web/web3Warning/web3Warning.hooks';
import { connectAddress } from 'modules/wallet/wallet.actions';
import { useDispatch, useSelector } from 'react-redux';
import { useWeb3React } from 'web3/hooks';
import { CashoutHandler } from './cashoutHandler';
import { VestHandler } from './vestHandler';
import { ClaimProps } from './claimUtils';

export const ClaimBody = ({ close, canClaim, type }: ClaimProps) => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const warning = useCurrentWarning({
    user,
    canClaim,
  });
  const { account } = useWeb3React();

  if (!user) return null;

  if (warning)
    return (
      <Web3Warning
        connectAddress={() => dispatch(connectAddress(account))}
        warning={warning}
      />
    );

  if (type == 'vest') return <VestHandler close={close} canClaim={canClaim} />;
  return <CashoutHandler close={close} canClaim={canClaim} />;
};
